var _style, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNhl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2000 2000",
    style: {
      enableBackground: "new 0 0 2000 2000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#D1D3D3;}\r\n\t.st2{fill:url(#SVGID_1_);}\r\n\t.st3{fill:url(#SVGID_2_);}\r\n\t.st4{fill:url(#SVGID_3_);}\r\n\t.st5{fill:url(#SVGID_4_);}\r\n\t.st6{fill:url(#SVGID_5_);}\r\n\t.st7{fill:url(#SVGID_6_);}\r\n\t.st8{fill:url(#SVGID_7_);}\r\n\t.st9{fill:url(#SVGID_8_);}\r\n\t.st10{fill:#030303;}\r\n\t.st11{fill:#F6F6F6;}\r\n\t.st12{fill:#F0B919;}\r\n\t.st13{fill:#22734D;}\r\n\t.st14{fill:#242020;}\r\n\t.st15{fill:#A7AAAB;}\r\n\t.st16{fill:#FDFDFD;}\r\n\t.st17{fill:#231F1F;}\r\n\t.st18{fill:#010101;}\r\n\t.st19{fill:#9FAAAD;}\r\n\t.st20{fill:#8E9090;}\r\n\t.st21{fill:#041E41;}\r\n\t.st22{fill:#7B303E;}\r\n\t.st23{fill:#AC162C;}\r\n\t.st24{fill:#55565A;}\r\n\t.st25{fill:#CF0A2C;}\r\n\t.st26{fill:#A7A9AC;}\r\n\t.st27{fill:#003D7D;}\r\n\t.st28{fill:#002D56;}\r\n\t.st29{fill:#003876;}\r\n\t.st30{fill:#002868;}\r\n\t.st31{fill:#002654;}\r\n\t.st32{fill:#FCB514;}\r\n\t.st33{fill:#002F87;}\r\n\t.st34{fill:#EA7200;}\r\n\t.st35{fill:#006D75;}\r\n\t.st36{fill:#F74902;}\r\n\t.st37{fill:#C8102E;}\r\n\t.st38{fill:#0033A0;}\r\n\t.st39{fill:#FFB81C;}\r\n\t.st40{fill:#041E42;}\r\n\t.st41{fill:#192168;}\r\n\t.st42{fill:#AF1E2D;}\r\n\t.st43{fill:#FC4C02;}\r\n\t.st44{fill:#B9975B;}\r\n\t.st45{fill:#CE1126;}\r\n\t.st46{fill:#A4A9AD;}\r\n\t.st47{fill:#236192;}\r\n\t.st48{fill:#111111;}\r\n\t.st49{fill:#A2AAAD;}\r\n\t.st50{fill:#6F263D;}\r\n\t.st51{fill:#D18A00;}\r\n\t.st52{fill:#00833E;}\r\n\t.st53{fill:#FFD100;}\r\n\t.st54{fill:#FF671B;}\r\n\t.st55{fill:#001970;}\r\n\t.st56{fill:#F3BC52;}\r\n\t.st57{fill:#003087;}\r\n\t.st58{fill-rule:evenodd;clip-rule:evenodd;fill:#FFB81C;}\r\n\t.st59{fill:#8C2633;}\r\n\t.st60{fill:#E2D6B5;}\r\n\t.st61{fill:#F95602;}\r\n\t.st62{fill:#B5985A;}\r\n\t.st63{fill:#024930;}\r\n\t.st64{fill:#AF1E24;}\r\n\t.st65{fill:#EDAA00;}\r\n\t.st66{fill:#80724F;}\r\n\t.st67{fill:#353E48;}\r\n\t.st68{fill:#F7F6F2;}\r\n\t.st69{fill:#E6E1D2;}\r\n\t.st70{fill:#050504;}\r\n\t.st71{fill:#D21D38;}\r\n\t.st72{fill:#AE9356;}\r\n\t.st73{fill:#A88E53;}\r\n\t.st74{fill:#A48B51;}\r\n\t.st75{fill:#08162C;}\r\n\t.st76{fill:#0E0E0E;}\r\n\t.st77{fill:#5B9EB6;}\r\n\t.st78{fill:#88D7D6;}\r\n\t.st79{fill:#CE072B;}\r\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M354.11,1173.23c0-147.36,68.98-203.8,84.65-344.89c-20.38,122.28-101.9,224.18-101.9,344.89 c0,47.03,6.27,89.36,18.81,126.98c51.73,170.88,203.8,264.94,352.73,302.56C479.53,1546.34,354.11,1355.08,354.11,1173.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1614.53,978.84c-28.22-67.41-58-126.98-58-202.23c0,180.28,86.22,230.45,86.22,396.62 c0,181.85-125.41,373.11-352.73,429.55c205.37-51.73,368.41-202.23,368.41-429.55C1658.43,1096.41,1636.48,1035.27,1614.53,978.84 z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1583.18,455.23c-47.03-14.11-79.95-48.6-100.33-105.03l-47.03-128.55l-21.95,81.52 c45.46,200.66,210.07,214.77,210.07,214.77l67.41-31.35L1583.18,455.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M802.47,1184.2l-86.22-131.69l-95.63,72.11c0,0,32.92,1.57,32.92,36.06v249.26l67.41-50.17v-177.15 l76.82,117.58l72.11-53.3v-310.4l-67.41,50.17V1184.2L802.47,1184.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1078.38,895.75l-76.82,58V839.31L898.1,916.13c0,0,32.92,1.57,32.92,36.06v249.26l68.98-51.73v-112.87 l76.82-58v112.87l65.84-50.17V732.71l-65.84,50.17C1078.38,781.31,1078.38,895.75,1078.38,895.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1271.21,867.53V637.08l-103.47,76.82c0,0,32.92,1.57,32.92,36.06v249.26l192.83-144.23 c-4.7-50.17,0-78.38,0-78.38L1271.21,867.53z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 2060.6597,
    y1: 4272.5898,
    x2: 2690.8105,
    y2: 4272.5898,
    gradientTransform: "matrix(0.2752 0 0 0.2752 -274.3468 -268.31)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1124,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    style: {
      stopColor: "#DDDFE1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4393,
    style: {
      stopColor: "#A8AFB3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5393,
    style: {
      stopColor: "#949CA1"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M391.74,776.61c0,175.58-86.22,211.64-86.22,395.06c0,56.44,9.41,109.74,26.65,156.77 c6.27-9.41,14.11-18.81,23.52-28.22c-10.97-39.19-18.81-81.52-18.81-126.98c0-120.71,81.52-221.04,101.9-344.89 c1.57-15.68,3.14-32.92,3.14-51.73c0-141.09-67.41-258.67-67.41-258.67l-67.41-31.35l45.46,103.47 C374.49,641.78,391.74,704.49,391.74,776.61z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 1623.9382,
    y1: 3564.7883,
    x2: 1623.9382,
    y2: 3072.2109,
    gradientTransform: "matrix(1 0 0 1 0 -2585.9521)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3483,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5618,
    style: {
      stopColor: "#949CA1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#949CA1"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1556.53,776.61c0,73.68,29.79,134.82,58,202.23l36.06-1.57c-21.95-56.44-45.46-109.74-45.46-200.66 c0-72.11,17.24-136.39,40.76-188.12l45.46-103.47l-67.41,31.35C1622.37,517.94,1556.53,637.08,1556.53,776.61z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 332.7451,
    y1: 4127.5869,
    x2: 999.0108,
    y2: 4127.5869,
    gradientTransform: "matrix(1 0 0 1 0 -2585.9521)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1517,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.212,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2863,
    style: {
      stopColor: "#EBECED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3681,
    style: {
      stopColor: "#D2D5D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4546,
    style: {
      stopColor: "#AFB5B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5112,
    style: {
      stopColor: "#949CA1"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M945.13,1657.64c-54.87-20.38-130.12-26.65-238.29-53.3c-147.36-39.19-301-133.25-351.16-304.13 c-9.41,7.84-17.24,18.81-21.95,29.79c58,164.61,203.8,279.05,362.13,319.81c101.9,25.08,148.93,28.22,224.18,48.6 c9.41,10.97,79.95,84.66,79.95,84.66v-72.11C998.43,1712.51,952.97,1663.91,945.13,1657.64z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 1392.7227,
    y1: 4095.9185,
    x2: 605.3571,
    y2: 2971.4443,
    gradientTransform: "matrix(1 0 0 1 0 -2585.9521)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#949CA1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0259,
    style: {
      stopColor: "#9DA5AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1259,
    style: {
      stopColor: "#C2C7CB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    style: {
      stopColor: "#DADDDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2528,
    style: {
      stopColor: "#E4E5E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7528,
    style: {
      stopColor: "#E4E5E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7982,
    style: {
      stopColor: "#DCDEE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8685,
    style: {
      stopColor: "#C6CBCF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9543,
    style: {
      stopColor: "#A6ADB2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#949CA1"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M719.38,1555.74c120.71,29.79,199.1,34.49,252.4,59.57c0,0,18.81,17.24,26.65,25.08 c7.84-7.84,26.65-25.08,26.65-25.08c53.3-25.08,131.69-28.22,252.4-59.57c152.07-39.19,316.67-172.45,316.67-382.51 c0-150.5-86.22-205.37-86.22-396.62c0-128.55,48.6-227.31,48.6-227.31s-112.87-21.95-166.17-164.61c0,0-75.25,68.98-177.15,68.98 c-128.55,0-214.77-89.36-214.77-89.36s-86.22,89.36-214.77,89.36c-103.47,0-177.15-68.98-177.15-68.98 c-53.3,142.66-166.17,164.61-166.17,164.61s48.6,98.76,48.6,227.31c0,191.26-86.22,246.13-86.22,396.62 C402.71,1383.3,567.32,1516.55,719.38,1555.74z M1537.72,1173.23c0,178.72-142.66,294.72-274.34,329.21 c-95.63,23.52-211.64,36.06-247.69,56.44c-7.84,6.27-17.24,15.68-17.24,15.68s-9.41-10.97-17.24-15.68 c-36.06-20.38-152.07-32.92-247.69-56.44c-3.14-1.57-7.84-1.57-10.97-3.14l750.92-562.8 C1500.09,1025.87,1537.72,1083.87,1537.72,1173.23z M1484.41,579.08c-15.68,45.46-32.92,116.01-32.92,197.53 c0,34.49,3.14,64.28,6.27,90.93l-805.79,603.56c-100.33-51.73-189.69-150.5-194.39-286.89l926.5-692.92 C1417,535.18,1454.63,563.4,1484.41,579.08z M545.37,776.61c0-81.52-17.24-152.07-32.92-197.53 c36.06-18.81,79.95-53.3,116.01-112.87c37.62,21.95,92.49,42.33,156.77,42.33c95.63,0,172.45-42.33,214.77-73.68 c42.33,31.35,119.14,73.68,214.77,73.68c15.68,0,29.79-1.57,43.9-3.14l-790.11,591.02C490.5,1007.05,545.37,933.37,545.37,776.61z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 561.9985,
    y1: 2900.0903,
    x2: 998.4245,
    y2: 2900.0903,
    gradientTransform: "matrix(1 0 0 1 0 -2585.9521)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2472,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3376,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4492,
    style: {
      stopColor: "#EBECED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5718,
    style: {
      stopColor: "#D2D5D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7015,
    style: {
      stopColor: "#AFB5B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7865,
    style: {
      stopColor: "#949CA1"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M783.66,405.06c130.12,0,214.77-109.74,214.77-109.74v-68.98l-67.41,67.41 c-34.49,34.49-90.93,62.71-147.36,62.71c-42.33,0-81.52-18.81-116.01-47.03l-105.03-86.22l21.95,81.52 C584.56,303.16,683.33,405.06,783.66,405.06z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 998.4323,
    y1: 3966.8994,
    x2: 1691.3486,
    y2: 3966.8994,
    gradientTransform: "matrix(1 0 0 1 0 -2585.9521)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1966,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3281,
    style: {
      stopColor: "#FAFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4746,
    style: {
      stopColor: "#EDEEEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6282,
    style: {
      stopColor: "#D7DADC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7858,
    style: {
      stopColor: "#B8BDC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9326,
    style: {
      stopColor: "#949CA1"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1658.43,1173.23c0,227.31-163.04,377.81-368.41,429.55c-108.17,26.65-183.42,34.49-238.29,53.3 c-7.84,6.27-53.3,56.44-53.3,56.44v72.11c0,0,68.98-75.25,79.95-84.65c75.25-20.38,122.28-23.52,224.18-48.6 c203.8-53.3,388.79-230.45,388.79-478.14c0-89.36-20.38-142.66-40.76-195.96l-36.06,1.57 C1636.48,1035.27,1658.43,1096.41,1658.43,1173.23z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 998.4323,
    y1: 2899.3066,
    x2: 1434.8739,
    y2: 2899.3066,
    gradientTransform: "matrix(1 0 0 1 0 -2585.9521)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2472,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3376,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4492,
    style: {
      stopColor: "#EBECED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5719,
    style: {
      stopColor: "#D2D5D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7016,
    style: {
      stopColor: "#AFB5B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7865,
    style: {
      stopColor: "#949CA1"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1213.21,405.06c100.33,0,199.1-101.9,199.1-101.9l21.95-81.52l-105.03,86.22 c-34.49,28.22-73.68,47.03-116.01,47.03c-56.44,0-112.87-28.22-147.36-62.71l-67.41-65.84v68.98 C998.43,295.33,1083.09,405.06,1213.21,405.06z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 306.6401,
    y1: 2955.7432,
    x2: 583.9226,
    y2: 2955.7432,
    gradientTransform: "matrix(1 0 0 1 0 -2585.9521)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3876,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4677,
    style: {
      stopColor: "#FAFAFA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5665,
    style: {
      stopColor: "#EBECED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6751,
    style: {
      stopColor: "#D2D5D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    style: {
      stopColor: "#AFB5B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8652,
    style: {
      stopColor: "#949CA1"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M584.56,303.16l-21.95-81.52L515.59,350.2c-20.38,54.87-54.87,90.93-100.33,105.03l-106.6,31.35l67.41,31.35 C374.49,517.94,539.1,503.83,584.56,303.16z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M371.36,776.61c0,169.31-86.22,208.5-86.22,395.06c0,271.21,210.07,448.36,406.03,498.52 c98.76,23.52,128.55,25.08,217.91,47.03c7.84,7.84,90.93,97.2,90.93,97.2s83.09-89.36,90.93-97.2 c89.36-21.95,119.14-23.52,217.91-47.03c195.96-50.17,406.03-227.31,406.03-498.52c0-188.12-86.22-225.75-86.22-395.06 c0-61.14,12.54-120.71,39.19-178.72l54.87-125.41l-130.12-37.62c-39.19-10.97-68.98-42.33-86.22-90.93l-58-156.77l-128.55,106.6 c-34.49,28.22-68.98,42.33-101.9,42.33c-45.46,0-97.2-21.95-131.69-56.44l-87.79-83.09l-83.09,81.52 c-34.49,34.49-86.22,56.44-131.69,56.44c-34.49,0-68.98-14.11-103.47-42.33l-128.55-106.6l-56.44,158.34 c-17.24,48.6-47.03,79.95-86.22,90.93L277.3,472.47l54.87,125.41C358.82,655.89,371.36,715.47,371.36,776.61z M413.69,455.23 c47.03-14.11,79.95-48.6,100.33-105.03l47.03-128.55l105.03,86.22c34.49,28.22,73.68,47.03,116.01,47.03 c56.44,0,112.87-28.22,147.36-62.71l68.98-65.84l67.41,67.41c34.49,34.49,90.93,62.71,147.36,62.71 c42.33,0,81.52-18.81,116.01-47.03l105.03-86.22l47.03,128.55c20.38,54.87,54.87,90.93,100.33,105.03l106.6,31.35l-45.46,103.47 c-23.52,51.73-40.76,116.01-40.76,188.12c0,90.93,23.52,144.23,45.46,200.66c20.38,51.73,40.76,106.6,40.76,195.96 c0,247.69-184.99,424.84-388.79,478.14c-101.9,25.08-148.93,28.22-224.18,48.6c-9.41,10.97-79.95,84.66-79.95,84.66 s-68.98-75.25-79.95-84.66c-75.25-20.38-122.28-23.52-224.18-48.6c-153.63-43.9-299.43-159.9-359-324.51 c-17.24-48.6-26.65-101.9-26.65-156.77c0-184.99,86.22-219.48,86.22-395.06c0-72.11-17.24-136.39-40.76-188.12l-45.46-103.47 L413.69,455.23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.52,1499.31c3.14,1.57,7.84,1.57,10.97,3.14c95.63,23.52,211.64,36.06,247.69,56.44 c7.84,6.27,17.24,15.68,17.24,15.68s9.41-10.97,17.24-15.68c36.06-20.38,152.07-32.92,247.69-56.44 c131.69-32.92,274.34-150.5,274.34-329.21c0-89.36-39.19-147.36-64.28-236.72L722.52,1499.31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.56,1096.41L1257.1,505.4c-14.11,1.57-28.22,3.14-43.9,3.14c-97.2,0-172.45-42.33-214.77-73.68 c-42.33,31.35-119.14,73.68-214.77,73.68c-64.28,0-117.58-21.95-156.77-42.33c-36.06,59.57-79.95,94.06-116.01,112.87 c15.68,45.46,32.92,116.01,32.92,197.53C545.37,933.37,490.5,1007.05,468.56,1096.41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.97,1471.09l805.79-603.56c-4.7-26.65-6.27-56.44-6.27-90.93c0-81.52,17.24-152.07,32.92-197.53 c-29.79-17.24-67.41-43.9-100.33-89.36L459.15,1184.2C462.28,1320.59,551.64,1419.36,651.97,1471.09z M1271.21,637.08v230.45 l122.28-92.49c0,0-4.7,29.79,0,78.38l-191.26,145.79V749.95c0-34.49-32.92-36.06-32.92-36.06L1271.21,637.08z M1001.57,839.31 v114.44l76.82-58V781.31l65.84-50.17v310.4l-65.84,50.17V978.84l-76.82,58v112.87l-68.98,51.73V952.19 c0-34.49-32.92-36.06-32.92-36.06L1001.57,839.31z M716.25,1052.52l86.22,131.69V988.24l67.41-50.17v310.4l-70.55,51.73 l-76.82-117.58v175.58l-68.98,51.73v-249.26c0-34.49-32.92-36.06-32.92-36.06L716.25,1052.52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.77,828.34c-14.11,141.09-84.65,195.96-84.65,344.89c0,181.85,125.41,373.11,352.73,429.55 c108.17,26.65,183.42,34.49,238.29,53.3c7.84,6.27,53.3,56.44,53.3,56.44s45.46-50.17,53.3-56.44 c54.87-20.38,130.12-26.65,238.29-53.3c227.31-58,352.73-247.69,352.73-429.55c0-164.61-86.22-216.34-86.22-396.62 c0-141.09,67.41-258.67,67.41-258.67s-166.17-14.11-211.64-214.77c0,0-98.76,101.9-199.1,101.9 c-130.12,0-214.77-109.74-214.77-109.74s-84.65,109.74-214.77,109.74c-100.33,0-199.1-101.9-199.1-101.9 C539.1,503.83,374.49,517.94,374.49,517.94s67.41,119.14,67.41,258.67C440.34,795.42,440.34,812.66,438.77,828.34z M440.34,549.29 c0,0,112.87-21.95,164.61-164.61c0,0,75.25,68.98,177.15,68.98c130.12,0,216.34-89.36,216.34-89.36s86.22,89.36,214.77,89.36 c103.47,0,177.15-68.98,177.15-68.98c51.73,142.66,164.61,164.61,164.61,164.61s-48.6,98.76-48.6,227.31 c0,191.26,86.22,246.13,86.22,396.62c0,210.07-164.61,343.32-316.67,382.51c-120.71,29.79-199.1,34.49-252.4,59.57 c0,0-18.81,17.24-26.65,25.08c-7.84-7.84-26.65-25.08-26.65-25.08c-53.3-25.08-131.69-28.22-252.4-59.57 c-150.5-39.19-315.1-172.45-315.1-382.51c0-150.5,86.22-205.37,86.22-396.62C488.94,648.05,440.34,549.29,440.34,549.29z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNhl);
export default __webpack_public_path__ + "static/media/NHL.0ba5a065ad3bef29c2558b23a2e21d21.svg";
export { ForwardRef as ReactComponent };